import { Box, selectClasses, Tabs } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { useState, useEffect, useRef } from 'react'
import { makeLogRequest } from '../../../utils/AuditLogs'
import { useDispatch, useSelector } from 'react-redux'
import { getMpList } from '../../../store/action/mpList'
import { getMpProfile } from '../../../store/action/individualMP'
import LeaderBoardTab from '../LeaderBoardTab/LeaderBoardTab'
import { pushTag } from '../../../utils/gtmservice'
import { getIds } from '../../ReusableComponents.js/getIds'
import './LeaderBoardTabs.css'
import { getEngagementMpData } from 'store/action/getEngagemnetData'

const LeaderBoardTabs = ({
  dataFilter,
  setSelectedCard,
  flag,
  setFlag,
  setCardLoading,
  tenure,
  selectedCard,
  tabsData,
  setTabData,
}) => {
  const isBdayCampaignEnabled = JSON.parse(localStorage.getItem('isBdayCampaignEnabled') || false)
  const data = useSelector((state) => state?.leaderboardtabs?.data?.tabs)
  const isSurveyCampaignEnabled = JSON.parse(localStorage.getItem('isSurveyCampaignEnabled') || false)
  const [tabactive, settabactive] = useState(!isSurveyCampaignEnabled ? 0 : 1)
  const containerRef = useRef(null)
  const [scrollLeft, setScrollLeft] = useState(0)
  const [scrollRight, setScrollRight] = useState(true)
  const [isDragging, setIsDragging] = useState(false)
  const [isCurrentTab, setCurrentTab] = useState(false)
  const [startX, setStartX] = useState(0)
  const [initialLoadComplete, setInitialLoadComplete] = useState(false)
  const loggedInId = getIds()
  const dispatch = useDispatch()

  useEffect(() => {
    if (selectedCard && containerRef.current) {
      if (!initialLoadComplete && tabsData.length > 0 && selectedCard.id === tabsData[0]?.id) {
        containerRef.current.scrollLeft = 0
        setInitialLoadComplete(true)
      } else if (tabsData.length > 0) {
        const selectedIndex = tabsData.findIndex((tab) => tab.id === selectedCard.id)
        if (selectedIndex > 0) {
          const tabWidth = containerRef.current.scrollWidth / tabsData.length
          const scrollPosition = tabWidth * selectedIndex - containerRef.current.clientWidth / 2 + tabWidth / 2

          const maxScroll = containerRef.current.scrollWidth - containerRef.current.clientWidth
          const safeScrollPosition = Math.max(0, Math.min(scrollPosition, maxScroll))

          containerRef.current.scrollLeft = safeScrollPosition
        }
      }
      updateScrollIndicators()
    }
  }, [selectedCard, containerRef.current, tabsData])

  useEffect(() => {
    if (selectedCard && tabsData.length > 0) {
      const updatedTabData = tabsData.find((tab) => tab.id === selectedCard.id)

      if (updatedTabData && JSON.stringify(updatedTabData) !== JSON.stringify(selectedCard)) {
        setSelectedCard(updatedTabData)
        localStorage.setItem('activetab', JSON.stringify(updatedTabData))
      }
    }
  }, [tabsData])

  const sendGALog = (event, message) => {
    pushTag({
      event: event,
      page_title: 'leaderboard_page',
      message: message,
    })
  }

  const updateScrollIndicators = () => {
    const container = containerRef.current
    if (!container) return

    setScrollLeft(container.scrollLeft)

    if (
      Math.floor(container.scrollLeft) + container.clientWidth >= container.scrollWidth - 1 ||
      Math.ceil(container.scrollLeft) + container.clientWidth >= container.scrollWidth
    ) {
      setScrollRight(false)
    } else {
      setScrollRight(true)
    }
  }

  useEffect(() => {
    fetchAllData()
  }, [flag, dataFilter, tenure, selectedCard])

  const fetchAllData = async () => {
    if (selectedCard) {
      try {
        setCardLoading(true)
        const startTime = Date.now()
        const lastData = JSON.parse(localStorage.getItem('leaderBoardSelectedItem') || '{}')
        const { flag: previouslySelected } = lastData

        if (!selectedCard.hasOwnProperty('csvPath')) {
          await dispatch(getMpList(selectedCard?.value, 1, dataFilter, tenure === 'Modi2.0' ? '2.o' : null))
        } else {
          await dispatch(getEngagementMpData(selectedCard?.id, 1))
        }

        const elapsedTime = Date.now() - startTime
        const minLoaderTime = 400

        if (elapsedTime < minLoaderTime) {
          await new Promise((resolve) => setTimeout(resolve, minLoaderTime - elapsedTime))
        }
      } catch (error) {
        console.log('Error', error)
      } finally {
        setCardLoading(false)
      }
    }
  }

  const handleMouseMove = (event) => {
    if (!isDragging) return
    event.preventDefault()
    const x = event.pageX - containerRef.current.offsetLeft
    const distance = (x - startX) * 2
    containerRef.current.scrollLeft = scrollLeft - distance
  }

  const handleMouseUp = () => {
    setIsDragging(false)
  }

  const handleMouseDown = (event) => {
    setIsDragging(true)
    setStartX(event.pageX - containerRef.current.offsetLeft)
    setScrollLeft(containerRef.current.scrollLeft)
  }

  useEffect(() => {
    if (containerRef.current) {
      updateScrollIndicators()
    }
  }, [containerRef?.current?.scrollLeft])

  const scrollLeftTab = () => {
    const container = containerRef.current
    if (!container) return

    container.scrollTo({
      left: container.scrollLeft - container.offsetWidth / 2,
      behavior: 'smooth',
    })

    setTimeout(updateScrollIndicators, 300)
  }

  const scrollRightTab = () => {
    const container = containerRef.current
    if (!container) return

    container.scrollTo({
      left: container.scrollLeft + container.offsetWidth / 2,
      behavior: 'smooth',
    })

    setTimeout(updateScrollIndicators, 300)
  }

  const setSelection = (tabdata) => {
    setSelectedCard(tabdata)
    localStorage.setItem('activetab', JSON.stringify(tabdata))
    setCurrentTab(tabdata)

    const parameters = {
      useridtype: getIds(),
    }
    if (selectedCard?.value) {
      makeLogRequest('mp_leaderboard', log[selectedCard?.value], parameters)
      sendGALog('select_option', log[selectedCard?.value])
    }
  }
  const log = {
    sevaScore: 'mp_seva_score',
    memberAdded: 'members_added',
    followers: 'followers',
    twitterPerformance: 'twitter_performance',
    mediaCoverage: 'op_eds_and_media_coverage',
    donation: 'donations',
    initiatives: 'initiatives',
  }

  return (
    <Box className="filter-btns no-gutters pt-3 leaderboard-options-outer-container cursorshow">
      <ChevronLeft
        sx={{
          color: scrollLeft === 0 ? 'grey' : 'black',
          cursor: scrollLeft !== 0 && 'pointer',
        }}
        onClick={scrollLeftTab}
      />
      <Tabs
        variant="scrollable"
        scrollButtons={false}
        aria-label="scrollable auto tabs example"
        sx={{ width: '94.5%' }}
      >
        <Box
          aria-label="scrollable auto tabs example"
          ref={containerRef}
          className="leaderBoardScrollbar leaderboard-options-inner-container"
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        >
          {tabsData.map((tabData, index) =>
            tabData?.disabled ? null : (
              <LeaderBoardTab
                tabData={tabData}
                onClick={() => {
                  setSelection(tabData)
                }}
                isCurrentTab={isCurrentTab}
              />
            )
          )}
        </Box>
      </Tabs>
      <ChevronRight
        sx={{
          color: !scrollRight ? 'grey' : 'black',
          cursor: scrollRight && 'pointer',
        }}
        onClick={scrollRightTab}
      />
    </Box>
  )
}

export default LeaderBoardTabs
